<template>
  <div class="root">
   <iframe class="root" :src="this.src">

    </iframe>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  // https://cms.qianxueyunke.com/stu-client/#/stu-liveclass?
  name: 'StuLiveRoom',
  data () {
    return {
      src: ''
    }
  },
  mounted () {
    let mid = this.$route.query.mid
    let gid = this.$route.query.gid
    this.getToken(mid, gid)
  },
  methods: {
    getToken: function (mid, gid) {
      var data = {room_id: mid, group_id: gid, user_type: 0}
      this.$api.liveServer.getToken(data).then(res => {
        console.log(res)
        if (res.code !== 0) {
          return
        }
        // 获取token, 开始进入房间
        let token = res.data.token
        let name = res.data.nick_name
        let roomproxy = this.$route.query.roomproxy
        let wbproxy = this.$route.query.wbproxy
        let chatproxy = this.$route.query.chatproxy
        let proxyUrl = ''
        if (roomproxy) {
          proxyUrl += '&roomproxy=' + roomproxy
        }
        if (chatproxy) {
          proxyUrl += '&chatproxy=' + chatproxy
        }
        if (wbproxy) {
          proxyUrl += '&wbproxy=' + wbproxy
        }
        this.src =  Vue.prototype.baseServer.liveRoomUrl + '/stu-client/#/stu-liveclass?' + 'token=' + token + '&name=' + name + '' + proxyUrl
      }).catch(err => {
        return this.$message.error(err.msg)
      })
    }
  }
}
</script>

<style>
  .root{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/page/stuSystem/StuLiveRoom.vue